import Cookie from 'js-cookie'
import CookieInteractor from './CookieInteractor'

export const cookieInteractor = new CookieInteractor(Cookie)

export default { cookieInteractor }
